<!-- 不良品分析 驳回重新提交 -->
<template>
  <table_component :kindType="data.kindType" :getData="data.getData" @routerBack="routerBack"
    @save="save" @submitSave="submitSave" v-if="data.getInfoFlag" :subLoading="data.subLoading">
  </table_component>
</template>



<script setup>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

  import { reactive, getCurrentInstance, onMounted, onUpdated, nextTick, onBeforeMount, onActivated, onDeactivated } from "vue";
  import { useRoute } from "vue-router";
  import axios from "axios";
  import table_component from "../tableComponent/index.vue"
  const { proxy, ctx } = getCurrentInstance()
  const route = useRoute()

  const data = reactive({
    kindType:'save',
    subLoading:false,
    getInfoFlag:false,
    getData:{},
    subLoading:false,
  })
  const routerBack = () => {
    proxy.$router.back()
  }
  // 保存
  const save = (val) =>{
    data.subLoading = true
    proxy.$http({
      url:'/base/emr/supplierCheckZanCun',
      method:'post',
      data:{
        ...data.getData,
        ...val,
        dataFrom:undefined,
        analysisActualDate:undefined,
        sqeAuditTime:'',
        sqeAuditConclusion:'',
        sqeAuditMessage:'',
      }
    }).then(res=>{
      if(res.data.code === '200'){
          proxy.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message:res.data.data,confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback:action => {
            if(action == 'confirm'){
              routerBack()
            }
          }})
      }else{
          proxy.info(res.data.data)
        }
    }).catch(err=>{

    }).finally(()=>{
      data.subLoading = false
    })
  }
  // 提交
  const submitSave = (val) =>{
    data.subLoading = true
    proxy.$http({
      url:'/base/emr/supplierCheckSubmit',
      method:'post',
      data:{
        ...data.getData,
        ...val,
        dataFrom:undefined,
        analysisActualDate:undefined,
        sqeAuditTime:'',
        sqeAuditConclusion:'',
        sqeAuditMessage:'',
      }
    }).then(res=>{
      if(res.data.code === '200'){
          proxy.success({title:h_i18n('330363dfc524cff2488f2ebde0500896'),message:res.data.data,confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
          callback:action => {
            if(action == 'confirm'){
              routerBack()
            }
          }})
      }else{
          proxy.info(res.data.data)
        }
    }).catch(err=>{

    }).finally(()=>{
      data.subLoading = false
    })
  }
  const getInfo = () => {
    proxy.startLoading(h_i18n('8f64f3e8f07e9b00a0eca21f01a208c6'))
    proxy.$http({
      url:'/base/emr/getOne',
      method:'post',
      params:{
        id:data.id
      }
    }).then(res=>{
      if(res.data.code === '200'){
        data.getData = res.data.data
        data.getData.dataFrom = route.query.dataFrom
        data.getData.id = data.getData.id || data.id
        data.getInfoFlag = true
        if(res.data.data.borrowProductNum){
          console.log(res.data.data.borrowProductNum)
          proxy.$http({
            url:'/base/emr/listPage',
            method:'post',
            data:{
              phenomenaCode:data.getData.phenomenaCode, // 故障码
              mtlNo:data.getData.mtlNo, // 专用号
              sybId:data.getData.sybId, // 工厂小微
              supplyCode:data.supplyCode,
              productNum:data.getData.borrowProductNum,
              searchFlag: 'supply'
            }
          }).then(res=>{
            if (res.data.code === "200") {
              data.getData.borrowId = res.data.data.records[0].id
            } else {
            }
          }).catch(err=>{

          }).finally(()=>{
            
          })
        
        }
      }
    }).catch(err=>{

    }).finally(()=>{
      proxy.closeLoading()
    })
  }
  onBeforeMount(()=>{
    if (route.query) {
      data.supplyCode = route.query.supplyCode ?  route.query.supplyCode : ''
      data.supplyName = route.query.supplyName || ''
      data.kindType = route.query.kindType ? route.query.kindType : 'save'
      data.id = route.query.id ?  route.query.id : undefined
    }
  })
  onMounted(() => {
    if(route.query.dataFrom != 'sqm'){
      proxy.$router.replace('/404')
      return
    }
    if(!route.query.supplyCode){
      proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('c0f92e28b64a4268408f10aa60dc47c8'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
        callback: (action) => {
          proxy.$router.back()
        },})
      return
    }
    data.id ? getInfo() : proxy.info({title: h_i18n('02d9819ddaaaeb1b7b22b12608c7e5ca'), message: h_i18n('9d98c8524e1a5638c9bedd0fb5c22fde'),confirmButtonText: h_i18n('38cf16f2204ffab8a6e0187070558721'),
    callback: (action) => {
      proxy.$router.back()
    },})
    for(let i = 1 ; i < 10; i++){
      setTimeout(() => {
        proxy.postThisPageHeightMore()
      }, i*100);
    }
  })

</script>

<style>

</style>